<template>
	<div class="containerDebitDetail">
		<h3>Pagamentos</h3>
		<p>Método de pagamento: {{ acordo.forma_de_pagamento }}</p>
		<div class="container-table">
			<table class="table-payments">
				<tr>
					<th>Parcela</th>
					<th>Vencimento</th>
					<th>Valor</th>
					<th>Status</th>
					<th>{{ textoVisualizacao }}</th>
				</tr>
				<tr v-for="cobranca in cobrancas"
					:key="cobranca.codigo_acordo_item">
					<td>{{ `${cobranca.parcela}/${cobrancas.length}` }}</td>
					<td>{{ cobranca.vencimento }}</td>
					<td>R$ {{ cobranca.valor }}</td>
					<td>{{ cobranca.status }}</td>
					<td v-if="acordo.forma_de_pagamento == 'BOLETO'">
						<i v-if="cobranca.boleto"
						:style="{ color: parceiro ? parceiroConfig.estilo.corPrimaria : '#003e6c' }"
						class="fas fa-file-pdf"
						@click="openCobranca(cobranca.boleto)" ></i>
					</td>
					<td v-if="acordo.forma_de_pagamento == 'PIX'">
						<i :style="{ color: parceiro ? parceiroConfig.estilo.corPrimaria : '#003e6c' }"
							class="fas fa-qrcode"
							@click="parcelaSelecionada = cobranca.codigo_acordo_item"></i>
						<tela-qr-code-pix
							v-if="parcelaSelecionada == cobranca.codigo_acordo_item"
							:pixCopiaECola="cobranca.pix_copia_e_cola"
							@fechar="parcelaSelecionada = 0"></tela-qr-code-pix>
					</td>
					<td v-if="acordo.forma_de_pagamento == 'LINK'">
						<i :style="{ color: parceiro ? parceiroConfig.estilo.corPrimaria : '#003e6c' }"
							class="fas fa-external-link-alt"
							@click="openCobranca(cobranca.link_de_pagamento)"></i>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import TelaQrCodePix from "./TelaQrCodePix.vue";

export default {
	name: "PaymentOptionsAgreement",
	props: ["acordo"],
	components: {
		TelaQrCodePix
	},
	data() {
		return {
			parcelaSelecionada: 0
		}
	},
	mounted() {
		this.action_salvar_etapa({
			pes_codigo: this.acordo.pes_codigo,
			esn_fk_ets_codigo: 35,
			loj_codigo: this.acordo.loja.loja_codigo,
			emp_codigo: this.parceiroConfig.emp_codigo
		}).then((response) => {});
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig
		}),

		cobrancas() {
			return this.acordo.boletos ? this.acordo.boletos : this.acordo.cobrancas;
		},

		textoVisualizacao() {
			return this.acordo.forma_de_pagamento == 'BOLETO' ? 'Baixar' : 'Visualizar';
		}
	},
	methods: {
		...mapActions(["action_salvar_etapa"]),

		openCobranca(cobranca) {
			if(this.acordo.loja.loj_usa_api_recupera == 'S') {
				// Exemplo de string Base64 de um PDF
				const base64PDF = cobranca;

				// Decodifica a string Base64
				const binaryString = atob(base64PDF);

				// Converte a string bin�ria para um array de bytes
				const byteNumbers = new Uint8Array(
				binaryString.split("").map((char) => char.charCodeAt(0))
				);

				// Cria um Blob a partir dos bytes
				const blob = new Blob([byteNumbers], { type: "application/pdf" });

				// Gera uma URL tempor�ria para o Blob
				const blobURL = URL.createObjectURL(blob);

				// Abre o PDF em uma nova aba
				window.open(blobURL, "_blank");

				// Libera a URL tempor�ria depois que a aba for aberta (opcional, mas recomendado)
				setTimeout(() => URL.revokeObjectURL(blobURL), 10000); 
				return;
			}

			let mensagemCobranca = !this.parceiroConfig.sessoes.customization.campos.myDebits.flgSafrapay ? 'Visualizou o boleto' : 'Visualizou a cobranca';
			this.action_salvar_etapa({
				pes_codigo: this.acordo.pes_codigo,
				esn_fk_ets_codigo: 4,
				loj_codigo: this.acordo.loja.loja_codigo,
				emp_codigo: this.parceiroConfig.emp_codigo,
				motivo_agendamento: mensagemCobranca
			}).then((response) => {});
			window.open(cobranca, "_blank");
		}
	}
};
</script>

<style scoped lang="scss">
.containerDebitDetail {
	width: 100%;
	box-sizing: border-box;
	max-width: 750px;
	padding: 30px;
	background: var(--whiteColor);
	border-radius: 40px;
	box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	margin-bottom: 100px;
}

.header-debits {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	max-width: 750px;
	cursor: pointer;
}

h3 {
	color: #031b4e;
	font-family: "Roboto Black";
	text-transform: uppercase;
	font-size: 16px;
	text-align: center;
}

p {
	text-align: center;
	margin-bottom: 30px;
	margin-top: 3px;
	color: #5b6987;
	font-family: "Roboto";
	font-size: 12px;
}

.header-debits i {
	font-size: 48px;
	color: #031b4e;
}
.payment {
	width: 100%;
	height: 45px;
	background: #eee;
	margin-bottom: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.table-payments {
	text-align: center;
}

.container-table {
	@media only screen and (max-width: 990px) {
		overflow-x: scroll;
	}
}

table {
	border-collapse: collapse;
	width: 100%;
}

table th {
	border: 1px solid #f2f2f2;
	padding: 8px;
}

table td {
	border: 1px solid #f8f8f8;
	padding: 8px;
}

table th {
	color: #031b4e;
	font-family: "Roboto Black";
	font-size: 16px;
	text-align: center;
	background: #f8f8f8;
}

table td {
	height: 45px;
	text-align: center;
	color: #5b6987;
	font-family: "Roboto";
	font-size: 12px;
	border-collapse: collapse;
}

.td-status {
	font-family: "Roboto Black";
}

.td-status i {
	font-size: 9px;
}

table td i:hover {
	cursor: pointer;
}

.td-status.confirmed {
	color: green;
}

</style>
